export const USER_SET = 'USER_SET';
export const USER_REMOVE = 'USER_REMOVE';
export const USER_MARKETING_EMAIL_OPT_IN_SET = 'USER_MARKETING_EMAIL_OPT_IN_SET';
export const USER_MARKETING_EMAIL_OPT_IN_PROMPT = 'USER_MARKETING_EMAIL_OPT_IN_PROMPT';
export const USER_LOGIN_LOADING_SET = 'USER_LOGIN_LOADING_SET';
export const USER_LANGUAGE_SET = 'USER_LANGUAGE_SET';
export const USER_CONTACT_DETAILS_CONFIRMED_PROMPT = 'USER_CONTACT_DETAILS_CONFIRMED_PROMPT';
export const USER_EMAIL_CONFIRMED_SET = 'USER_EMAIL_CONFIRMED_SET';
export const CONTACT_SET = 'CONTACT_SET';
export const USER_ADDRESS_UPDATED = 'USER_ADDRESS_UPDATED';
export const YAGA_UUID = 'YAGA_UUID';
